import { IHighlightsFolder } from '@/types/highlight.interface'

export const getFolderNameError = (
	name: string,
	folders: IHighlightsFolder[],
	excludeFolderId?: number
) => {
	const trimmedName = name.trim()

	if (!trimmedName) return ''

	const isDuplicate = folders.some(folder => {
		if (folder.id === excludeFolderId) return false

		return folder.name.trim().toLowerCase() === trimmedName.toLowerCase()
	})

	return isDuplicate ? 'This folder name already exists' : ''
}
